/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Payment_UnavailableInputs */

const en_checkout_payment_unavailable = /** @type {(inputs: Checkout_Payment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment isn't going through on our side right now — nothing was charged, and retrying won't help. Please contact us and we'll hold these dates and finish your booking by hand.`)
};

/**
* | output |
* | --- |
* | "Payment isn't going through on our side right now — nothing was charged, and retrying won't help. Please contact us and we'll hold these dates and finish you..." |
*
* @param {Checkout_Payment_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_payment_unavailable = /** @type {((inputs?: Checkout_Payment_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Payment_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_payment_unavailable(inputs)
});